import { lazyPreviewAttachment } from 'owa-attachment-preview-sxs-actions';
import { previewAttachment } from 'owa-attachment-select-actions/lib/actions/publicActions';
import { orchestrator } from 'satcheljs';

orchestrator(previewAttachment, actionMessage => {
    const { context } = actionMessage;
    lazyPreviewAttachment.importAndExecute(context);
});
